import { render, staticRenderFns } from "./vehicleDetails.vue?vue&type=template&id=21ca5241"
import script from "./vehicleDetails.vue?vue&type=script&lang=js"
export * from "./vehicleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports